import './PrisingCard.css';

import React from 'react'
import { Link } from "react-router-dom";
const PrisingCard = () => {
  return (
    <div>
      <div className="prising">
        <div className="card-container">
            <div className="card">
                <h3>-Basic-</h3>
                <span className="bar"></span>
                <h1 className="btc">$100</h1>
                <p>-3 Days-</p>
                <p>-3 Pages-</p>
                <p>-Featured-</p>
                <p>-Responsive Design-</p>
                <Link to="/contact" className="btn">
                    PURCHASE NOW
                </Link>
            </div>
        </div>
      </div>
      <div className="prising">
        <div className="card-container">
            <div className="card">
                <h3>-Premium-</h3>
                <span className="bar"></span>
                <h1 className="btc">$200</h1>
                <p>-2 Days-</p>
                <p>-5 Pages-</p>
                <p>-Featured-</p>
                <p>-Responsive Design-</p>
                <Link to="/contact" className="btn">
                    PURCHASE NOW
                </Link>
            </div>
        </div>
      </div>
      <div className="prising">
        <div className="card-container">
            <div className="card">
                <h3>-Business-</h3>
                <span className="bar"></span>
                <h1 className="btc">$300</h1>
                <p>-5 Days-</p>
                <p>-8 Pages-</p>
                <p>-Featured-</p>
                <p>-Responsive Design-</p>
                <Link to="/contact" className="btn">
                    PURCHASE NOW
                </Link>
            </div>
        </div>
      </div>
    </div>
  )
}

export default PrisingCard
